import { gql } from 'apollo-boost';
import { client } from '../Common/gql/client';
import { InstitutionApp } from '../Common/types/AppConfigTypes';

const embeddableAppQuery = gql`
    {
        institutionAppsEmbeddable {
            config
            embeddableApp {
                uuid
                slug
            }
        }
    }
`;

export const getCFAppConfig = async () => {
    const results = await client.query({ query: embeddableAppQuery });
    const { institutionAppsEmbeddable } = results.data;

    const curriculumFinderApp = institutionAppsEmbeddable.find(
        ({ embeddableApp }: InstitutionApp) =>
            embeddableApp.slug === 'curriculum-finder',
    );

    if (typeof curriculumFinderApp.config === 'string') {
        try {
            return {
                ...curriculumFinderApp.embeddableApp,
                config: JSON.parse(curriculumFinderApp.config),
            };
        } catch (e) {
            console.error(e);
        }
    } else {
        return {
            ...curriculumFinderApp.embeddableApp,
            config: curriculumFinderApp.config,
        };
    }
};
